export default "__VITE_ASSET__Cvgv9Urp__"